import { FilterOutlined, RocketOutlined } from '@ant-design/icons';
import {
  AsyncFilterDropdown,
  SimpleFilterDropdown
} from 'app/components/Dropdown/EnhancedFilter';
import Toolbar from 'app/components/Toolbar';
import { DataObject } from 'app/services/types/IResponse';
import { JOB_STATUS_OPTION, RESULT_OPTIONS } from 'app/utils/constants';
import { transformToOptions } from 'app/utils/transforms';
import { Moment } from 'moment';
import React from 'react';

type Sorter = {
  value: string;
  direction: 'desc' | 'asc';
  range?: [Moment, Moment];
};

type Props = {
  filtered: {
    result: string[];
    status: string[];
  };
  sorter: Sorter;
  onChangeFilter: (filter: Record<string, string[]>) => void;
  onChangeSort: (sorter: { value: string; direction: 'asc' | 'desc' }) => void;
  // onChangeSearch: (keywords: string) => void;
};

export const JobFilter = (props: Props) => {
  const [filters, setFilters] = React.useState<Record<string, any>>({
    result: [],
    status: [],
    typeOfService: [],
    inspectors: []
  });
  const [sorter, setSorter] = React.useState<Sorter>({
    value: '',
    direction: 'desc',
    range: undefined
  });

  const onChangeFilter = (filterName: string) => (value: any | any[]) => {
    const nextFilter = { ...filters };
    nextFilter[filterName] = value;
    props.onChangeFilter(nextFilter);
    setFilters(nextFilter);
  };

  const onChangeSort = (value: any) => {
    setSorter(value);
    props.onChangeSort(value);
  };
  React.useEffect(() => {
    setSorter(props.sorter);
    setFilters(props.filtered);
  }, [props.filtered, props.sorter]);

  return (
    <Toolbar size={4}>
      <SimpleFilterDropdown
        key={'result'}
        allOption={{ value: 'all', label: 'All Result' }}
        options={RESULT_OPTIONS}
        value={filters['result']}
        onApply={onChangeFilter('result')}
        onReset={() => {}}
        icon={<FilterOutlined />}
        renderLabel={(config) => {
          const { selected } = config;
          if (selected.length) {
            return `Result(${selected?.length ?? ''})`;
          }
          return 'All Result';
        }}
      />
      <SimpleFilterDropdown
        key={'status'}
        allOption={{ value: 'all', label: 'All Status' }}
        onApply={onChangeFilter('status')}
        onReset={() => {}}
        value={filters.status}
        options={JOB_STATUS_OPTION}
        icon={<RocketOutlined />}
        renderLabel={(config) => {
          const { selected } = config;
          if (selected.length) {
            return `Status(${selected?.length ?? ''})`;
          }
          return 'All Status';
        }}
      />

      <AsyncFilterDropdown
        showSearch
        isOption
        resource="admin/inspections/inspectors"
        pagination={{ current: 1, pageSize: 9999 }} // Get ALL Inspectors
        allOption={{ value: 'all', label: 'All Inspector' }}
        transformResponse={(response) => {
          const { data = {} } = response || {};
          const { list } = data as DataObject;
          return {
            data: transformToOptions(list, {
              transform: (item) => {
                return {
                  value: item.id,
                  label: [item.firstName, item.lastName]
                    .filter((value) => !!value)
                    .join(' ')
                };
              }
            })
          };
        }}
        onApply={onChangeFilter('inspectors')}
        icon={<FilterOutlined />}
        value={filters.inspectors}
        renderLabel={(config) => {
          const { selected } = config;
          if (Array.isArray(selected) && selected.length) {
            return `Inspector(s)(${selected.length})`;
          }
          return 'All Inspector';
        }}
      />
      <AsyncFilterDropdown
        showSearch
        isOption
        resource="inspections/type-of-services"
        onApply={onChangeFilter('typeOfService')}
        value={filters.typeOfService}
        icon={<FilterOutlined />}
        allOption={{ value: 'all', label: 'All Inspection Type' }}
        renderLabel={(config) => {
          const { selected } = config;
          if (Array.isArray(selected) && selected.length) {
            return `Inspection Type(s)(${selected.length})`;
          }
          return 'All Inspection Type';
        }}
      />
      <Toolbar.Sorter
        value={[sorter.value]}
        direction={sorter.direction as any}
        dateRange={sorter.range}
        onApply={(selected, direction, dateRange) => {
          onChangeSort({
            value: selected,
            direction,
            range: dateRange
          });
        }}
        range
        options={[
          { value: 'inspectionDate', label: 'Inspection Date' },
          { value: 'createdAt', label: 'Date created' },
          { value: 'updatedAt', label: 'Date updated' }
        ]}
        directions={[
          { value: 'desc', label: 'Newest to Oldest' },
          { value: 'asc', label: 'Oldest to Newest' }
        ]}
      ></Toolbar.Sorter>
    </Toolbar>
  );
};
